import { render, staticRenderFns } from "./ForeignExchange.vue?vue&type=template&id=9d64065c&scoped=true"
import script from "./ForeignExchange.vue?vue&type=script&lang=js"
export * from "./ForeignExchange.vue?vue&type=script&lang=js"
import style0 from "./ForeignExchange.vue?vue&type=style&index=0&id=9d64065c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d64065c",
  null
  
)

export default component.exports